import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Blackout, CalendarEvent, ModelID } from '@/types';
import { post } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { CalendarEventSearchParams, featureKeys, featurePath } from '.';

type QueryFnType = typeof fetchCalendarEvents;

type SearchParams = CalendarEventSearchParams & {
  mode?: 'calendar' | 'scheduler';
  features?: string[];
};

type UseCalendarEventsOptions = {
  location: ModelID;
  search: SearchParams;
  config?: QueryConfig<QueryFnType>;
};

export type CalendarData = {
  events: CalendarEvent[];
  blackouts: Blackout[];
  revenue?: Record<string, number> | [];
};

export const fetchCalendarEvents = (location: ModelID, search: SearchParams) =>
  post<CalendarData>(`${featurePath}`, {
    franchise_id: location,
    start: search.start.toString(),
    end: search.end.toString(),
    mode: search.mode || 'calendar',
    inc_features: search.features || [],
  });

export const useCalendarEvents = ({ location, search, config = {} }: UseCalendarEventsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    staleTime: 50,
    queryKey: featureKeys.list(location, {
      ...search,
      start: search.start.toString(),
      end: search.end.toString(),
    }),
    queryFn: () => fetchCalendarEvents(location, search),
  });
};
